var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitArrowDownClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0004 2C15.7626 2.00012 18.0008 4.23759 18.0008 6.99961C18.0008 9.76167 15.7626 11.9999 13.0004 12C10.2382 12 8.00004 9.76174 8.00004 6.99961C8.00007 4.23751 10.2382 2 13.0004 2ZM12.6779 3.77403C12.5924 3.77403 12.5103 3.80796 12.4498 3.86838C12.3893 3.92887 12.3547 4.01096 12.3547 4.09651V7.23239C12.3547 7.3533 12.382 7.47295 12.4343 7.58193C12.4866 7.69076 12.5629 7.78637 12.6571 7.86188L14.0081 8.8649C14.0412 8.89136 14.0795 8.91111 14.1202 8.9229C14.1608 8.93464 14.2035 8.93762 14.2455 8.93295C14.2876 8.92827 14.3283 8.91549 14.3654 8.89506C14.4025 8.87462 14.4356 8.84694 14.462 8.81386L14.8649 8.31042C14.8915 8.27734 14.9111 8.23899 14.9229 8.19828C14.9347 8.15761 14.9384 8.11509 14.9338 8.073C14.9291 8.03094 14.9163 7.99023 14.8959 7.95314C14.8754 7.916 14.8478 7.88295 14.8147 7.85647L13.6454 6.99961V4.09651C13.6454 4.011 13.6115 3.92887 13.551 3.86838C13.4906 3.80791 13.4084 3.77406 13.3229 3.77403H12.6779Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15494 11.2066L4.48861 13.7067C4.07199 14.0974 3.39541 14.0974 2.9788 13.7067L0.312461 11.2066C-0.104154 10.816 -0.104154 10.1816 0.312461 9.79096C0.729076 9.40032 1.40566 9.40032 1.82227 9.79096L2.66883 10.5847V1.00003C2.66883 0.44689 3.14544 0 3.73537 0C4.3253 0 4.8019 0.44689 4.8019 1.00003V10.5847L5.64846 9.79096C6.06508 9.40032 6.74166 9.40032 7.15828 9.79096C7.57489 10.1816 7.57489 10.816 7.15828 11.2066H7.15494Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitArrowDownClock);
export default __webpack_public_path__ + "static/media/aitArrowDownClock.9438c3b15f9cd93ad83ffca40829ce98.svg";
export { ForwardRef as ReactComponent };